import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getLandsCadastralCases(companyId) {
	return dataTransferWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].getLandsCadastralCases,
		{
			urlParams: {
				companyId,
			},
		}
	)
}
function getBaseLandsCadastralCases(companyId) {
	return dataTransferWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].getBaseLandsCadastralCases,
		{
			urlParams: {
				companyId,
			},
		}
	)
}
function getExtendLandsCadastralCases(companyId) {
	return dataTransferWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].getExtendLandsCadastralCases,
		{
			urlParams: {
				companyId,
			},
		}
	)
}

function getLandsCadastralCase(companyId, cadastralCaseId) {
	return dataTransferWrap(
		ModulesMap.LANDS_CADASTRAL_CASES,
		dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].getLandsCadastralCase,
		{
			urlParams: {
				companyId,
				cadastralCaseId,
			},
		}
	)
}

function createLandsCadastralCase(companyId, payload) {
	return dataTransferWrap(ModulesMap.LANDS_CADASTRAL_CASES, dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].createLandsCadastralCase, {
		urlParams: {
			companyId,
		},
		...payload,
	})
}

function putLandsCadastralCase(companyId, cadastralCaseId, payload) {
	return dataTransferWrap(ModulesMap.LANDS_CADASTRAL_CASES, dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].putLandsCadastralCase, {
		urlParams: {
			companyId,
			cadastralCaseId,
		},
		...payload,
	})
}

function patchLandsCadastralCase(companyId, cadastralCaseId, payload) {
	return dataTransferWrap(ModulesMap.LANDS_CADASTRAL_CASES, dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].patchLandsCadastralCase, {
		urlParams: {
			companyId,
			cadastralCaseId,
		},
		...payload,
	})
}

function deleteLandsCadastralCase(companyId, cadastralCaseId) {
	return dataTransferWrap(ModulesMap.LANDS_CADASTRAL_CASES, dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].deleteLandsCadastralCase, {
		urlParams: {
			companyId,
			cadastralCaseId,
		},
	})
}

function getLandsCadastralCasePreview(companyId, cadastralCaseId) {
	return dataTransferWrap(ModulesMap.LANDS_CADASTRAL_CASES, dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].getLandsCadastralCasePreview, {
		urlParams: {
			companyId,
			cadastralCaseId,
		},
	})
}

function getLandsCadastralCasePopup(companyId, cadastralCaseId) {
	return dataTransferWrap(ModulesMap.LANDS_CADASTRAL_CASES, dtConfig[ModulesMap.LANDS_CADASTRAL_CASES].getLandsCadastralCasePopup, {
		urlParams: {
			companyId,
			cadastralCaseId,
		},
	})
}

export default {
	getLandsCadastralCases,
	getBaseLandsCadastralCases,
	getExtendLandsCadastralCases,
	getLandsCadastralCase,
	createLandsCadastralCase,
	putLandsCadastralCase,
	patchLandsCadastralCase,
	deleteLandsCadastralCase,
	getLandsCadastralCasePreview,
	getLandsCadastralCasePopup,
}
